/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-25 22:29:19
 * @LastEditTime: 2022-01-26 18:48:52
 * @LastEditors: zhao - 🍉
 * @Description: 
 * @FilePath: /zhzj-admin/src/page/ZJBSyncDataRecord/index.jsx
 */
import React, { useRef } from 'react'
import PageWrap from '../../components/PageWrap'
import TableHelper from '../../components/TableHelper'
import { fetchZJBSyncDataRecord } from '../../services/ZJBSyncDataRecord'
import BuildingDetailListModal from './components/BuildingDetailListModal'
import HouseDetailListModal from './components/HouseDetailListModal'
import MerchantDetailListModal from './components/MerchantDetailListModal'
import PayorderDetailListModal from './components/PayorderDetailListModal'
import ProjectDetailListModal from './components/ProjectDetailListModal'
import RentContractDetailListModal from './components/RentContractDetailListModal'

const ZJBSyncDataRecord = (props) => {
    const BuildingDetailListRef = useRef()
    const HouseDetailListRef = useRef()
    const MerchantDetailListRef = useRef()
    const PayorderDetailListRef = useRef()
    const ProjectDetailListRef = useRef()
    const RentContractDetailListRef = useRef()
    const columns = [
    
        { title: '同步日期', dataIndex: 'syncDate', width: 110 },
        { title: '收房合同', children: [
            { title: '同步数量',  dataIndex: 'houseContractAddNum', render: (text, record) => {
                return <a onClick={() => BuildingDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'houseContractUpdateNum', render: (text, record) => {
            //     return <a onClick={() => BuildingDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'houseContractDelNum', render: (text, record) => {
                return <a onClick={() => BuildingDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
        ]},
        { title: '房源', children: [
            { title: '同步数量',  dataIndex: 'houseAddNum', render: (text, record) => {
                return <a onClick={() => HouseDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'houseUpdateNum', render: (text, record) => {
            //     return <a onClick={() => HouseDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'houseDelNum', render: (text, record) => {
                return <a onClick={() => HouseDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
        ]},
        { title: '商户', children: [
            { title: '同步数量',  dataIndex: 'merchantAddNum', render: (text, record) => {
                return <a onClick={() => MerchantDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'merchantUpdateNum', render: (text, record) => {
            //     return <a onClick={() => MerchantDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'merchantDelNum', render: (text, record) => {
                return <a onClick={() => MerchantDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
            
        ]},
        { title: '订单', children: [
            { title: '同步数量',  dataIndex: 'orderAddNum', render: (text, record) => {
                return <a onClick={() => PayorderDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'orderUpdateNum', render: (text, record) => {
            //     return <a onClick={() => PayorderDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'orderDelNum', render: (text, record) => {
                return <a onClick={() => PayorderDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
           
        ]},
        { title: '项目', children: [
            { title: '同步数量',  dataIndex: 'projectAddNum', render: (text, record) => {
                return <a onClick={() => ProjectDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'projectUpdateNum', render: (text, record) => {
            //     return <a onClick={() => ProjectDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'projectDelNum', render: (text, record) => {
                return <a onClick={() => ProjectDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
        ]},
        { title: '租赁合同', children: [
            { title: '同步数量',  dataIndex: 'rentContractAddNum', render: (text, record) => {
                return <a onClick={() => RentContractDetailListRef.current.open(1, record.syncDate)}>{text}</a>
            } },
            // { title: '修改数量',  dataIndex: 'rentContractUpdateNum', render: (text, record) => {
            //     return <a onClick={() => RentContractDetailListRef.current.open(2, record.syncDate)}>{text}</a>
            // } },
            { title: '删除数量',  dataIndex: 'rentContractDelNum', render: (text, record) => {
                return <a onClick={() => RentContractDetailListRef.current.open(3, record.syncDate)}>{text}</a>
            } },
        ]},
        
    ]

    const searchOptions = [
        { key: 'syncDate', type: 'date', placeholder: '同步日期' }
    ]
    return (
        <PageWrap>
            <TableHelper 
                bordered 
                columns={columns} 
                searchOptions={searchOptions} 
                scroll={{x: 1700}}
                request={fetchZJBSyncDataRecord} 
            />
            <BuildingDetailListModal ref={BuildingDetailListRef} />
            <HouseDetailListModal ref={HouseDetailListRef} />
            <MerchantDetailListModal ref={MerchantDetailListRef} />
            <PayorderDetailListModal ref={PayorderDetailListRef} />
            <ProjectDetailListModal ref={ProjectDetailListRef} />
            <RentContractDetailListModal ref={RentContractDetailListRef} />
        </PageWrap>
    )
}

export default ZJBSyncDataRecord


// WEBPACK FOOTER //
// ./src/page/ZJBSyncDataRecord/index.jsx